import {globals, globalUser} from "../modules/globals.js";
import {commaSeparate, toTitleCase} from "../modules/helpers.js";
import {getChampionshipsDisplayName, replaceAll} from "./ui-helpers.js";

function displayEventPrestigeAndEffects(data) {
    const $eventPrestigeEffects = $(".event-prestige-effects");
    const $eventPrestigeEffectsContainer = $('.event-prestige-effects-container');
    const $eventPrestigeEffectsMoreIcon = $('.event-prestige-effects-more i');

    $('.event-card-weekly-show').hide();

    // Add prestige icon
    let prestigeIcon = getEventPrestigeIcon(data['prestige']);
    $('#event-card-name-details').append(prestigeIcon);

    // Add streaks, match effects and match contracts texts
    let eventEffectsContainer = $('<div class="light-container font-bold medium-grey"></div>');
    if (data['streaks'].length > 0) {
        const eventStreaksContainer = getEventEffectsStreaksHtml(data['streaks']);
        eventEffectsContainer.append(eventStreaksContainer);
    }
    if (data['matchEffects'].length > 0) {
        const eventMatchEffectsContainer = getEventEffectsMatchEffectsHtml(data['matchEffects']);
        eventEffectsContainer.append(eventMatchEffectsContainer);
    }
    if (data['matchContracts'].length > 0) {
        const eventMatchContractsContainer = getEventEffectsMatchContractsHtml(data['matchContracts']);
        eventEffectsContainer.append(eventMatchContractsContainer);
    }

    // Add event effects header
    let prestigeEffects = data['streaks'].concat(data['matchEffects'], data['matchContracts']);
    if (prestigeEffects.length > 0) {
        $('.event-prestige-effects-number').text(prestigeEffects.length);
    }
    else {
        $('.event-prestige-effects-number').text('No');
    }
    if (prestigeEffects.length === 1) {
        $('.event-prestige-effects-text').text('Event Effect');
    }
    else {
        $('.event-prestige-effects-text').text('Event Effects');
    }

    // Show 'expand event effects' icon
    $eventPrestigeEffectsContainer.html('');
    if (prestigeEffects.length < 1) {
        $eventPrestigeEffectsMoreIcon.hide();
        $('.event-prestige-effects-more').removeClass('cursor-pointer');
        $('.event-prestige-effects').addClass('grey').removeClass('medium-dark-grey cursor-pointer');
    }
    else {
        $eventPrestigeEffectsMoreIcon.removeClass('fa-angle-up').addClass('fa-angle-down');
        $eventPrestigeEffectsMoreIcon.show();
        $('.event-prestige-effects-more').addClass('cursor-pointer');
        $eventPrestigeEffects.addClass('medium-dark-grey cursor-pointer').removeClass('grey');
        $eventPrestigeEffectsContainer.append(eventEffectsContainer);
    }

    $eventPrestigeEffects.show();
    $eventPrestigeEffectsContainer.hide();

    // Show hype help
    $('.event-hype').addClass('help-text').attr('title', 'Event Hype affects the viewers/buys for the event.');

    // Show prestige help
    let eventPrestigeHelpText;
    if (globalUser.paid) {
        eventPrestigeHelpText = 'Event Prestige affects an event\'s Hype, its minimum and maximum matches and is linked to Event Effects. ' +
            'Event Prestige changes based on the Event\'s Rating.'
    }
    else {
        eventPrestigeHelpText = 'Event Prestige affects an event\'s Hype, its minimum and maximum matches and is linked to Event Effects. ' +
            'Event Prestige can only change in JoW Paid.'
    }
    $('.current-event-prestige-icon').addClass('help-text').attr('title', eventPrestigeHelpText);

    // Event effects help
    let eventEffectsHelpText;
    if (globalUser.paid) {
        eventEffectsHelpText = 'Event Effects include Streaks, Gimmick Match Effects and Match Contracts. Streaks can only be used ' +
            'on Gold Prestige Events.'
    }
    else {
        eventEffectsHelpText = 'Event Effects include Streaks, Gimmick Match Effects and Match Contracts. ' +
            'Streaks and Gimmick Match Effects can only be used in JoW Paid.'
    }
    $eventPrestigeEffects.addClass('help-text').attr('title', eventEffectsHelpText);
    $('.event-match-bonuses').addClass('help-text').attr('title', 'Gimmick Match Effects add a bonus or a penalty ' +
        'to Gimmick Matches held at this Event.');
    $('.event-match-contracts').addClass('help-text').attr('title', 'Match Contracts add a bonus if the contract holder\'s ' +
        'is in a Title Match at this Event and fan disappointment if not. The bonus depends on the Prestige of the current Event.');
    $('.event-streaks').addClass('help-text').attr('title', 'Streaks add a bonus to the defending Superstar\'s Match at this Event.');
}

function getEventPrestigeIcon(prestige) {
    let prestigeIcon;
    switch (prestige) {
        case 'C':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-7 font-0p925em current-event-prestige-icon' +
                ' bronze"></i>';
            break;
        case 'B':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-7 font-0p925em current-event-prestige-icon' +
                ' silver"></i>';
            break;
        case 'A':
            prestigeIcon = '<i class="fa fa-star-o font-bold margin-left-7 font-0p925em current-event-prestige-icon' +
                ' gold-light"></i>';
            break;
    }
    return prestigeIcon;
}

function getEventEffectsStreaksHtml(streaksData) {

    // Create container
    let eventStreaksContainer = $('<div class="bonuses-container"></div>');

    // Add header
    eventStreaksContainer.append('<div class="margin-bottom-2 medium-dark-grey event-streaks">Streaks</div>');

    // Add html for each streak
    streaksData.forEach(function (streakData) {
        if (streakData['length'] >= 2) {
            const streakHtml = getEventEffectsStreakHtml(streakData);
            eventStreaksContainer.append(streakHtml);
        }
    });

    // Add streak potentials
    const streakPotentials = streaksData.reduce(function (filtered, streak) {
        if (streak['length'] < 2) {
            filtered.push(streak['holder']);
        }
        return filtered;
    }, []);
    if (streakPotentials.length > 0) {
        const streakText = '<span class="light-grey">Streak Potential: {0}</span>'.format(
            streakPotentials.join(', ')
        );
        const streakHtml = '<div>' + streakText + '</div>';
        eventStreaksContainer.append(streakHtml);
    }

    return eventStreaksContainer;
}

function getEventEffectsStreakHtml(streakData) {

    // Get color depending on streak's length
    let streakClass = 'bronze';
    if (streakData['length'] < 5) {
        streakClass = 'bronze'
    }
    else if (streakData['length'] < 10) {
        streakClass = 'gold-light'
    }
    else if (streakData['length'] < 20) {
        streakClass = 'faded-red'
    }
    else {
        streakClass = 'obsidian'
    }

    // Get streak text
    let streakText;
    if (streakData['length'] >= 10) {
        streakText = '{0} <span class="{1} margin-left-3">{2}-0</span>'.format(
            streakData['holder'], streakClass, streakData['length']);
    } else {
        const winText = (streakData['length'] > 1) ? 'Wins' : 'Win';
        streakText = '{0} <span class="{1} margin-left-3">{2} {3}</span>'.format(
            streakData['holder'], streakClass, streakData['length'], winText);
    }

    return '<div>' + streakText + '</div>';
}

function getEventEffectsMatchEffectsHtml(matchEffectsData) {

    // Create container
    const eventMatchEffectsContainer = $('<div class="bonuses-container"></div>');

    // Add header
    eventMatchEffectsContainer.append(
        '<div class="margin-bottom-2 medium-dark-grey event-match-bonuses">Gimmick Match Effects</div>');

    // Add html for each match effect
    matchEffectsData.forEach(function (matchEffectData) {
        if (matchEffectData['bonus']) {
            const matchBonusHtml = getEventEffectsMatchEffectHtml(matchEffectData);
            eventMatchEffectsContainer.append(matchBonusHtml);
        }
    });

    // Add positive match effect potentials
    const positiveMatchEffectPotentials = matchEffectsData.reduce(function (filtered, matchBonus) {
        if (!matchBonus['bonus'] && matchBonus['points'] > 0) {
            filtered.push(matchBonus['gimmickMatch']);
        }
        return filtered;
    }, []);
    if (positiveMatchEffectPotentials.length > 0) {
        const matchBonusText = '<span class="light-grey">+ Effect Potential: {0}</span>'.format(
            positiveMatchEffectPotentials.join(', ')
        );
        const matchBonusHtml = '<div>' + matchBonusText + '</div>';
        eventMatchEffectsContainer.append(matchBonusHtml);
    }

    // Add negative match effect potentials
    const negativeMatchEffectPotentials = matchEffectsData.reduce(function (filtered, matchBonus) {
        if (!matchBonus['bonus'] && matchBonus['points'] < 0) {
            filtered.push(matchBonus['gimmickMatch']);
        }
        return filtered;
    }, []);
    if (negativeMatchEffectPotentials.length > 0) {
        const matchBonusText = '<span class="light-grey">- Effect Potential: {0}</span>'.format(
            negativeMatchEffectPotentials.join(', ')
        );
        const matchBonusHtml = '<div>' + matchBonusText + '</div>';
        eventMatchEffectsContainer.append(matchBonusHtml);
    }

    return eventMatchEffectsContainer;
}

function getEventEffectsMatchEffectHtml(matchEffectData) {

    // Get color depending on match effect's bonus
    let matchBonusClass = 'bronze';
    if (matchEffectData['bonus'] < 0) {
        matchBonusClass = 'puke-green'
    }
    else {
        matchBonusClass = 'gold'
    }

    // Format bonus text
    let bonusText;
    if (matchEffectData['bonus'] > 0) {
        bonusText = '+ ' + matchEffectData['bonus']
    }
    else {
        bonusText = '- ' + (matchEffectData['bonus'] * -1)
    }

    // Get match effect text
    const matchEffectText = '{0} <span class="{1} margin-left-3">{2} HYPE</span>'.format(
        matchEffectData['gimmickMatch'], matchBonusClass, bonusText);

    return '<div>' + matchEffectText + '</div>';
}

function getEventEffectsMatchContractsHtml(matchContractsData) {

    // Create container
    const eventMatchContractsContainer = $('<div class="bonuses-container"></div>');

    // Add header
    eventMatchContractsContainer.append('<div class="margin-bottom-2 medium-dark-grey event-match-contracts">Match Contracts</div>');

    // Add html for each match contract
    matchContractsData.forEach(function (matchContractData) {
        const matchContractHtml = getEventEffectsMatchContractHtml(matchContractData);
        eventMatchContractsContainer.append(matchContractHtml);
    });

    return eventMatchContractsContainer;
}

function getEventEffectsMatchContractHtml(matchContractData) {

    // Get color depending on match contract's bonus
    let matchContractClass;
    if (matchContractData['bonus'] < 25) {
        matchContractClass = 'bronze'
    }
    else if (matchContractData['bonus'] < 50) {
        matchContractClass = 'gold-light'
    }
    else if (matchContractData['bonus'] < 70) {
        matchContractClass = 'faded-red'
    }
    else {
        matchContractClass = 'obsidian'
    }

    // Get match contract text
    const matchContractText = '{0}<span class="margin-left-3 light-grey"> {1}</span><span class="{2} margin-left-3"> + {3} HYPE</span>'.format(
        matchContractData['holder'], matchContractData['name'],
        matchContractClass, matchContractData['bonus']
    );

    return '<div>' + matchContractText + '</div>';
}

function addEventCardMatchesAndSegments(matchesAndSegments) {
    if (matchesAndSegments.length > 0) {
        $("#matches").html('');
        matchesAndSegments.forEach(function (matchOrSegment, index) {
            // Add segment to card
            let matchOrSegmentHtml;
            if (matchOrSegment['segmentType'] === 'segment') {
                matchOrSegmentHtml = getEventCardSegmentHtml(matchOrSegment, index);
            } else {
                matchOrSegmentHtml = getEventCardMatchHtml(matchOrSegment, index)
            }
            $("#matches").append(matchOrSegmentHtml);
        });
    }
    else {
        $("#matches").html('<span class="font-bold display-block light-grey margin-bottom-10 margin-top-10 event-match-empty">' +
            'No matches or segments booked' + '</span>');
    }
    // Add match limits
    let matchLimitsHtml = getMatchLimitsHtml();
    $('#match-limits').html(matchLimitsHtml);
}

function getEventCardMatchHtml(match, index) {

    const $matches = $("#matches");

    // Show empty element if match is hidden
    if (match['hidden']) {
        return '<span class="event-match font-bold display-block hidden" tabindex="0">' +
        '<div class="event-match-column-left">' +
        '???' +
        '</div>' +
        '<div class="event-match-column-right">' +
        '</div>' +
        '<div class="clear"></div>' +
        '</span>';
    }

    // Main event indication
    let mainEventHtml = '';
    if ($matches.text() === 'No matches or segments booked' || index === 0) {
        if ($matches.text() === 'No matches or segments booked') {
            $matches.text('');
        }
        mainEventHtml = '<span class="main-event-label light-grey margin-bottom-3 display-block">Main Event</span>';
    }

    // Get gimmick info
    const matchGimmickHtml = getMatchGimmickHtml(match);

    // Get tournament info
    const matchTournamentHtml = getMatchTournamentHtml(match);

    // Get feud and feud buttons html
    const [feudsHtml, addFeudMenuHtml, removeFeudMenuHtml] = getMatchFeudsHtml(match);

    // Get participants html, check if managers present
    const [matchParticipantsHtml, managersPresent] = getMatchParticipantsHtml(match);

    // Get match championships html
    const [championshipHtml, removeChampionshipMenuHtml,
        selectChampionshipMenuHtml] = getMatchChampionshipsHtml(match);

    // Get starting html (classes, data attributes etc)
    let played = (match['winnerName']) ? ' played': '';
    let tournamentMatch = (match['tournamentRound']) ? ' tournament-match': '';
    let matchSpanStartHtml = '<span class="event-match font-bold display-block ' + tournamentMatch + played + '" data-uid="' +
        match['uid'] + '" data-matchtype="' + match['type'] + '" tabindex=0>';

    // If lots of participants, show help text with list of match's participants
    if (match['participants'].length > 10) {
        let participantNames = Array.from(match['participants'], function(s) {
            return s['name']
        });
        let titleNames = participantNames.join(', ').replace(/"/g, "&quot;");
        matchSpanStartHtml = '<span class="event-match font-bold display-block help-text ' + tournamentMatch + played + '" ' +
            'title="' + titleNames + '" data-uid="' + match['uid'] + '" data-matchtype="' + match['type'] +
            '" tabindex="0">';
    }

    // Check to disable match buttons
    let disabledClass = '';
    if (globals.game.annualTournamentRunning) {
        disabledClass = ' disabled'
    }

    // Get match buttons
    const [deleteMatchMenuHtml, addGimmickMatchMenuHtml, addMatchManagerMenuHtml,
        removeMatchManagerMenuHtml] = getMatchButtonsHtml(match, managersPresent);

    // Get remaining html
    return matchSpanStartHtml +
        '<div class="event-match-column-left">' +
        mainEventHtml +
        championshipHtml +
        matchParticipantsHtml +
        matchGimmickHtml +
        matchTournamentHtml +
        feudsHtml +
        '</div>' +
        '<div class="event-match-column-right">' +

        '<nav class="nav event-card-match-edit-menu">' +
            '<ul>' +
                '<li class="button-dropdown' + disabledClass + '">' +
                    '<div class="dropdown-toggle">Edit <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
                    '<ul class="dropdown-menu">' +
                        deleteMatchMenuHtml +
                        addFeudMenuHtml +
                        removeFeudMenuHtml +
                        addGimmickMatchMenuHtml +
                        selectChampionshipMenuHtml +
                        removeChampionshipMenuHtml +
                        addMatchManagerMenuHtml +
                        removeMatchManagerMenuHtml +
                    '</ul>' +
                '</li>' +
            '</ul>' +
        '</nav>' +

        '</div>' +
        '<div class="clear"></div>' +
        '</span>';
}

function getMatchGimmickHtml(match) {
    let matchGimmickHtml = '';

    if (match['gimmick']) {
        let matchGimmickText = '';
        // Show generated objects
        if (match['generated']['objectToClaim'] || match['generated']['location']) {
            if (match['generated']['objectToClaim']) {
                matchGimmickText = match['generated']['objectToClaim'] + ' on a Pole'
            } else if (match['generated']['location']) {
                matchGimmickText = match['generated']['location'] + ' Brawl'
            }
        } else {
            matchGimmickText = match['gimmick']
        }
        let refereeText = '';
        if (match['refereeName']) {
            refereeText = ' w/ ' + match['refereeName']
        }

        matchGimmickHtml = '<span class="display-block grey margin-top-2">'
            + matchGimmickText + ' Match' + refereeText +
            '</span>';
    }

    return matchGimmickHtml;
}

function getMatchTournamentHtml(match) {
    let matchTournamentHtml = '';

    if (match['tournamentName']) {
        let group = '';
        if (match['tournamentGroup']) {
            group = ' - Group {0}'.format(match['tournamentGroup'])
        }
        matchTournamentHtml = '<span class="display-block grey margin-top-2">' +
            match['tournamentName'] +
            '<span class="light-grey margin-left-5">' + match['tournamentRoundName'] + group + '</span>' +
            '</span>';
    }

    return matchTournamentHtml;
}

function getMatchFeudsHtml(match) {
    let matchFeudsHtml = '';
    let addFeudMenuHtml = '';
    let removeFeudMenuHtml = '';

    // Add html for each feud
    if (match['feuds'] && match['feuds'].length > 0) {
        let feudsHtml = '';
        match['feuds'].forEach(function (feudData) {
            const getMatchFeudHtmlData = getMatchFeudHtml(feudData, match);
            feudsHtml += getMatchFeudHtmlData.feudHtml;
            removeFeudMenuHtml = getMatchFeudHtmlData.removeFeudMenuHtml;
        });
        matchFeudsHtml += '<span class="display-block margin-top-2 line-height-24px">' + feudsHtml + '</span>';
    }
    else {
        // Add 'add feud' button if no match feuds present
        if (match['participants'].length === 2 && !match['winnerName']) {
            addFeudMenuHtml = '<li class="event-card-match-add-feud-button">' +
            '<span>Add Feud</span>' +
            '</li>'
        }
    }
    return [matchFeudsHtml, addFeudMenuHtml, removeFeudMenuHtml];
}

function getMatchFeudHtml(feudData, match) {

    let removeFeudMenuHtml = '';

    // Add feud name
    let feudName = '';
    if (feudData['participants']) {
        let feudParticipants = feudData['participants'].join(' vs ').replace(/"/g, "&quot;");
        feudName = '<span class="help-text" title="' + feudParticipants + '">' + feudData['name'] + '</span>';
    } else {
        feudName = '<span>' + feudData['name'] + '</span>';
    }

    let blowoffButton = '';
    let feudHype = '';

    // Add remove feud button if feud not started and 1 feud in match
    if (!feudData['started'] && match['feuds'].length === 1) {
        if (!match['winnerName']) {
            removeFeudMenuHtml = '<li class="event-card-match-remove-feud-button">' +
                '<span>Remove Feud</span>' +
                '</li>';
        }
    }
    else {
        // Add 'add blowoff' button if feud started
        if (!match['winnerName'] && feudData['started']) {
            blowoffButton = '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 ' +
                'add-blowoff-to-feud" data-uid="' + match['uid'] + '" data-match-type="' + match['type'] + '" ' +
                'data-feud-uid="' + feudData['uid'] + '">Add Blowoff</span>';
        }
        // Add 'remove blowoff' button if running blowoff
        if (feudData['runBlowoff'] && !match['winnerName']) {
            feudName += ' <span>Blowoff</span>';
            blowoffButton = '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 ' +
                'remove-blowoff-from-feud" data-uid="' + match['uid'] + '" data-match-type="' + match['type'] + '" ' +
                'data-feud-uid="' + feudData['uid'] + '">Remove Blowoff</span>';
        }

        // Add feud hype
        feudHype = '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + Math.round(feudData['hype']);
    }

    // Get feud html
    const feudHtml = '<span class="faded-red-light match-feud-name display-block">' +
        feudName + feudHype + blowoffButton + '</span>';

    return {feudHtml, removeFeudMenuHtml};
}

function getMatchParticipantsHtml(match) {
    let participantsHtml;
    let participantsHtmlsArray = [];
    let managersPresent = false;

    // For empty participants (tournaments/random opponent)
    if (match['participants'].length === 0) {
        match['participants'] = [{'name': '???'}, {'name': '???'}]
    }
    if (match['participants'].length === 1) {
        match['participants'].push({'name': '???'})
    }

    // Get html for each participant
    match['participants'].forEach(function(participant) {
        const getMatchParticipantHtmlData = getMatchParticipantHtml(participant, match);
        const participantHtml = getMatchParticipantHtmlData.participantHtml;
        if (getMatchParticipantHtmlData.managersPresent) {
            managersPresent = true;
        }
        participantsHtmlsArray.push('<span class="event-card-match-participant">' + participantHtml + '</span>');
    });

    // If lots of participants, condense participants htmls
    if (match['participants'].length > 10) {
        // If match winner, move to start of array
        participantsHtmlsArray.sort(function (x, y) {
            return x.includes(match['winnerName']) ? -1 : y.includes(match['winnerName']) ? 1 : 0;
        });

        // Condense participants list to top 10
        let condensedParticipants = participantsHtmlsArray.slice(0, 10);
        let othersText;
        if ((match['participants'].length - 10) > 1) {
            othersText = 'others'
        }
        else {
            othersText = 'other'
        }
        let othersTextHtml = (match['participants'].length - 10) + ' ' + othersText;
        if (match['winnerName']) {
            othersTextHtml = '<span class="event-card-match-loser">' + othersTextHtml + '</span>'
        }
        condensedParticipants.push(othersTextHtml);
        participantsHtml = condensedParticipants.join('<span class="font-weight-normal"> vs </span>');
    }
    else {
        participantsHtml = participantsHtmlsArray.join('<span class="font-weight-normal"> vs </span>');
    }

    // Add active effect indication
    let activeEffectHtml = '';
    if (match['activeEffect']) {
        activeEffectHtml = '<img alt="Artifact" src="static/www/static/powerup_1_icon_small.png" class="artifact-image-small left-0 help-text margin-left-6" title="' +
            toTitleCase(replaceAll(match['activeEffect'], '_', ' ')) +
            '"/>';
    }

    participantsHtml = '<div class="event-match-participants-container line-height-24px">' + participantsHtml + activeEffectHtml + '</div>';

    return [participantsHtml, managersPresent];
}

function getMatchParticipantHtml(participant, match) {
    let managersPresent = false;
    let participantHtml = '<span class="event-card-match-participant-name">' + participant['name'] + '</span>';

    // Add name
    if (match['winnerName']) {
        if (participant['name'] !== match['winnerName']) {
            participantHtml = '<span class="event-card-match-loser event-card-match-participant-name">'
                + participant['name'] + '</span>'
        }
    }

    // Add champion label
    if (participant['champion']) {
        participantHtml += '<span class="light-grey margin-left-3 font-15px top--1px ' +
            'event-card-champion-label">(c)</span>'
    }

    // Add 'change' button for trio tag team
    if (participant['trioTagTeam'] && !match['winnerName'] && participant['trioMembers']) {
        let teamMembers =  JSON.stringify(participant['trioMembers']).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let teamMembersSelected =  JSON.stringify(participant['trioMembersSelected']).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let teamName = JSON.stringify(participant['name']).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline margin-left-5 margin-right-3' +
            ' change-trio-tagteam-members" data-trio-members=\'' + teamMembers + '\' ' +
            'data-trio-members-selected=\'' + teamMembersSelected + '\' ' +
            'data-match-uid="' + match['uid'] + '" data-team-name=\'' + teamName + '\'>Change</span>'
    }

    // Add 'change' button for faction tag team
    if (participant['factionTagTeam'] && !match['winnerName'] && participant['factionMembers']) {
        let factionMembers =  JSON.stringify(participant['factionMembers']).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let factionMembersSelected =  JSON.stringify(participant['factionMembersSelected']).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        let teamName = JSON.stringify(participant['name']).replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        participantHtml += '<span class="button retro-button event-card-button grey-button-background display-inline light-grey margin-left-5 margin-right-3' +
            ' change-faction-tagteam-members" data-faction-members=\'' + factionMembers + '\' ' +
            'data-faction-members-selected=\'' + factionMembersSelected + '\' ' +
            'data-match-uid="' + match['uid'] + '" data-team-name=\'' + teamName + '\' data-team-size="' +
            participant['factionMembersSelected'].length + '">Change</span>'
    }

    // Show alternate attires button if present
    if (match['type'] !== 'tag') {
        if (participant['alternateAttires'] && !match['winnerName']) {
            let currentAttire = String.fromCharCode(65 + participant['currentAttire']);
            participantHtml += '<span class="button retro-button event-card-button grey-button-background' +
                ' display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" ' +
                'title="Change attire" data-uid="' + participant['uid'] + '">' + currentAttire + '</span>';
        }
    }
    // Show alternate attires buttons for each member of tag team if any of them have alternate attires present
    else {
        if (participant['members']) {
            let attiresPresent = participant['members'].some(function (el) {
                return el['alternateAttires'];
            });
            if (attiresPresent) {
                participant['members'].forEach(function (member) {
                    let currentAttire = String.fromCharCode(65 + member['currentAttire']);
                    participantHtml += '<span class="button retro-button event-card-button grey-button-background' +
                        ' display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" ' +
                        'title="Change attire for ' + member['name'] + '" data-uid="' + member['uid'] + '">' + currentAttire + '</span>';
                })
            }
        }
    }

    // Add managers
    let managersHtml = getMatchParticipantManagersHtml(participant);
    participantHtml += managersHtml;
    if (managersHtml) {
        managersPresent = true
    }

    return {participantHtml, managersPresent};
}

function getMatchButtonsHtml(match, managersPresent) {

    // Delete match button
    let deleteMatchMenuHtml = '';
    if (!match['winnerName']) {
        deleteMatchMenuHtml = '<li class="event-card-match-delete-button">' +
            '<span>Delete</span>' +
            '</li>'
    }

    // Add gimmick match button
    let addGimmickMatchMenuHtml = '';
    if (!match['gimmick'] && !match['winnerName']) {
        addGimmickMatchMenuHtml = '<li class="event-card-match-add-gimmick-button">' +
            '<span>Add Gimmick</span>' +
            '</li>'
    }

    // Add manager button
    let addMatchManagerMenuHtml = '';
    if (!match['winnerName'] && globalUser.paid) {
        addMatchManagerMenuHtml = '<li class="event-card-match-add-manager-button">' +
            '<span>Add Manager</span>' +
            '</li>'
    }

    // Remove manager button if managers present
    let removeMatchManagerMenuHtml = '';
    if (managersPresent && !match['winnerName'] && globalUser.paid) {
        removeMatchManagerMenuHtml = '<li class="event-card-match-remove-manager-button">' +
            '<span>Remove Man.</span>' +
            '</li>'
    }

    return [deleteMatchMenuHtml, addGimmickMatchMenuHtml, addMatchManagerMenuHtml, removeMatchManagerMenuHtml];
}

function getMatchChampionshipsHtml(match) {
    let championshipHtml = '';
    let removeChampionshipMenuHtml = '';
    let selectChampionshipMenuHtml = '';
    if (match['championships'].length > 0) {
        // Name
        let championshipText = getChampionshipsDisplayName(match['championships'], null, true);

        if (!match['winnerName']) {
             removeChampionshipMenuHtml = '<li class="event-card-match-remove-championship-button">' +
                 '<span>Remove Title</span>' +
                 '</li>'
        }
        championshipHtml = '<span class="margin-right-5 display-block margin-bottom-2 gold match-championship-name">' +
            championshipText +
            '</span>';
    }

    if (match['championshipsAvailable'] && !match['winnerName']) {
        selectChampionshipMenuHtml = '<li class="event-card-match-select-championships-button">' +
             '<span>Select Titles</span>' +
             '</li>'
    }

    return [championshipHtml, removeChampionshipMenuHtml, selectChampionshipMenuHtml];
}

function getMatchParticipantManagersHtml(participant) {
    let managersHtml = '';
    let managerNames = [];

    if (participant['members']) {
        // Get manager names from team members
        managerNames = participant['members'].filter(function (member) {
            if (member['managerName']) {
                return member
            }
        }).map(function (member) {
            return member['managerName']
        });
    }
    else {
        // Get manager names from superstar
        if (participant['managerName']) {
            managerNames.push(participant['managerName']);
        }
    }

    if (managerNames.length > 0) {
        managersHtml = '<span class="margin-left-5 grey"><span>w/</span> {0}</span>'.format(commaSeparate(managerNames, ' <span>and</span> '));
    }

    return managersHtml;
}

function getEventCardSegmentHtml(segment, index) {
    if (typeof(index) === 'undefined') index = 1;

    // Show empty element if segment is hidden
    if (segment['hidden']) {
        return '<span class="event-match font-bold display-block hidden" tabindex="0">' +
        '<div class="event-match-column-left">' +
        '???' +
        '</div>' +
        '<div class="event-match-column-right">' +
        '</div>' +
        '<div class="clear"></div>' +
        '</span>';
    }

    let mainEventLabel = '';
    if (index === 0) {
        // If first match, reset empty card text, add main event label
        mainEventLabel = '<span class="main-event-label light-grey margin-bottom-3 display-block">Main Event</span>';
        $("#matches").text('');
    }

    let participantsHtml = '';
    if (segment['participants'].length > 0) {

        let participantsHtmls = [];
        segment['participants'].forEach(function (participant) {
            let participantHtml = participant['name'];

            if (segment['participantsType'] !== 'tag') {
                // Show alternate attires button if present
                if (participant['alternateAttires']) {
                    let currentAttire = String.fromCharCode(65 + participant['currentAttire']);
                    participantHtml += '<span class="button retro-button event-card-button grey-button-background' +
                        ' display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" ' +
                        'title="Change attire" data-uid="' + participant['uid'] + '">' + currentAttire + '</span>';
                }
            } else {
                if (participant['members']) {
                    // Show alternate attires buttons for each member of team if any of them have alternate attires present
                    let attiresPresent = participant['members'].every(function (el) {
                        return el['alternateAttires'];
                    });
                    if (attiresPresent) {
                        participant['members'].forEach(function (member) {
                            let currentAttire = String.fromCharCode(65 + member['currentAttire']);
                            participantHtml += '<span class="button retro-button event-card-button grey-button-background' +
                                ' display-inline margin-left-5 margin-right-3 change-superstar-attire-button help-text" ' +
                                'title="Change attire for ' + member['name'] + '" data-uid="' + member['uid'] + '">' + currentAttire + '</span>';
                        })
                    }
                }
            }

            // Add managers
            let managersHtml = getMatchParticipantManagersHtml(participant);
            participantHtml += managersHtml;

            participantsHtmls.push(participantHtml);
        });

        let participantsDetails = commaSeparate(participantsHtmls, '<span class="font-weight-normal">&</span>');
        participantsHtml = '<span class="display-block margin-top-2 line-height-24px">' + participantsDetails + '</span>';
    }

    // Add Feud Item
    let feudsHtml = '';
    let addFeudMenuHtml = '';
    let removeFeudMenuHtml = '';
    if (segment['feuds'].length > 0) {

        // Add all feuds
        let feudHtml = '';
        segment['feuds'].forEach(function (feud) {

            let feudName = '';
            if (feud['participants']) {
                let feudParticipants = feud['participants'].join(' vs ');
                feudName = '<span class="help-text" title="' + feudParticipants.replace(/"/g, "&quot;") + '">' + feud['name'] + '</span>';
            } else {
                feudName = '<span>' + feud['name'] + '</span>';
            }

            let feudHype = '';
            // Add remove feud button if feud not started and 1 feud in segment
            if (!feud['started'] && segment['feuds'].length === 1) {
                // Add remove feud button if feud not started
                if (!segment['played']) {
                    removeFeudMenuHtml = '<li class="event-card-match-remove-feud-button">' +
                        '<span>Remove Feud</span>' +
                        '</li>';
                }

            }
            else {
                feudHype = '<i class="fa fa-bolt margin-right-5 margin-left-8"></i>' + Math.round(feud['hype']);
            }

            feudHtml += '<span class="faded-red-light match-feud-name display-block">' +
                feudName + feudHype + '</span>';

        });
        feudsHtml += '<span class="display-block margin-top-2 line-height-24px">' + feudHtml + '</span>';
    }
    else {
        // Add feud button
        if (segment['participants'].length === 2 && !segment['played']) {
            addFeudMenuHtml = '<li class="event-card-match-add-feud-button">' +
            '<span>Add Feud</span>' +
            '</li>'
        }
    }

    let segmentText =
        '<span class="display-block faded-purple">' + segment['name'] + '</span>' +
        participantsHtml;

    // Producer name
    let producerHtml = '';
    if (segment['producerName']) {
        producerHtml = '<span class="display-block grey margin-top-2 help-text" ' +
            'title="Producer assigned to this segment.">' +
            segment['producerName'] + '</span>';
    }

    // Add/remove producer button
    let addSegmentProducerHtml = '';
    let removeSegmentProducerHtml = '';
    if (!segment['played'] && globalUser.paid) {
        if (segment['producerName']) {
            removeSegmentProducerHtml = '<li class="event-card-segment-remove-producer-button">' +
            '<span>Remove Producer</span>' +
            '</li>'
        }
        else {
            addSegmentProducerHtml = '<li class="event-card-segment-add-producer-button">' +
                '<span>Add Producer</span>' +
                '</li>'
        }
    }

    let deleteSegmentMenuHtml = '';
    if (!segment['played']) {
        deleteSegmentMenuHtml = '<li class="event-card-segment-delete-button">' +
            '<span>Delete</span>' +
            '</li>'
    }

    let disabledClass = '';
    if (globals.game.annualTournamentRunning) {
        disabledClass = ' disabled'
    }

    let played = (segment['played']) ? ' played': '';
    return '<span class="event-match segment font-bold display-block' + played + '" data-uid="' + segment['uid'] +
        '" data-matchtype="' + segment['participantsType'] + '" data-is-segment="true" tabindex="0">' +
        '<div class="event-match-column-left">' +
        mainEventLabel +
        segmentText + feudsHtml + producerHtml +
        '</div>' +
        '<div class="event-match-column-right">' +

            '<nav class="nav event-card-match-edit-menu">' +
                '<ul>' +
                    '<li class="button-dropdown' + disabledClass + '">' +
                        '<div class="dropdown-toggle">Edit <i class="fa fa-sort-down top--2px margin-left-3"></i></div>' +
                        '<ul class="dropdown-menu">' +
                            deleteSegmentMenuHtml +
                            addFeudMenuHtml +
                            removeFeudMenuHtml +
                            addSegmentProducerHtml +
                            removeSegmentProducerHtml +
                        '</ul>' +
                    '</li>' +
                '</ul>' +
            '</nav>' +
        '</div>' +
        '<div class="clear"></div>' +
        '</span>';
}

function getMatchLimitsHtml() {
    const numberOfMatches = $('#matches').find('.event-match').length;
    const maximumHelpText = 'Maximum matches/segments are determined by the Prestige of the upcoming Event and the level of your Production Facility.';
    const minimumHelpText = 'Minimum matches/segments are determined by the Prestige of the upcoming Event and the number of available Superstars.';

    const minimumText = '{0}'.format(globals.game.minimumMatchesAndSegments);
    const minimumHtml = (numberOfMatches < globals.game.minimumMatchesAndSegments || numberOfMatches >= globals.game.maximumMatchesAndSegments) ?
    '<span class="help-text" title="{0}">Min {1}</span>'.format(minimumHelpText, minimumText) :
    '<span class="green help-text" title="{0}">Min</span> {1}</span>'.format(minimumHelpText, minimumText);

    const maximumText = '{0}'.format(globals.game.maximumMatchesAndSegments);
    const maximumHtml = (numberOfMatches < globals.game.maximumMatchesAndSegments) ?
    '<span class="help-text" title="{0}">Max {1}</span>'.format(maximumHelpText, maximumText) :
    '<span class="red help=text" title="{0}">Max</span> {1}</span>'.format(maximumHelpText, maximumText);

    const slotsLeft = globals.game.maximumMatchesAndSegments - numberOfMatches;
    const slotsLeftHtml = '<span class="margin-left-7 medium-grey "> {0} left</span>'.format(slotsLeft);

    return '<div>{0} <span class="margin-left-7">{1}</span>{2}</div>'.format(minimumHtml, maximumHtml, slotsLeftHtml);
}

function updateEventCardBrand(data) {
    const $eventCardName = $("#event-card-name");
    const $eventCardBrand = $('.event-card-brand');

    // Add brand name
    $eventCardName.html(
        '<span>' + data['name'] + '</span>'
    );

    $eventCardName.css('color', '');
    $eventCardBrand.hide();
    if (data['brandName'] && !data['weeklyShow']) {
        // Show brand for monthly event
        if (data['brandColor'] && !globalUser.settings.colorblindMode) {
            $eventCardBrand.css('color', data['brandColor'])
        } else {
            $eventCardBrand.css('color', '')
        }
        $eventCardBrand.text(data['brandName']).show();
    } else {
        // Color event name for weekly show
        if (data['weeklyShow']) {
            if (data['brandColor'] && !globalUser.settings.colorblindMode) {
                $eventCardName.css('color', data['brandColor'])
            }
            else {
                $eventCardName.css('color', '')
            }
        }
        $eventCardBrand.hide();
    }
}

export {displayEventPrestigeAndEffects, addEventCardMatchesAndSegments, updateEventCardBrand,
    getMatchParticipantManagersHtml, getEventCardSegmentHtml, getMatchLimitsHtml, getEventCardMatchHtml}